import { LOGIN_ROUTE_PATH } from '@/router/constants';
import { $fetch } from '@/utils/fetch';

const TOKEN_KEY = 'openatom-talent-profile-api-token';
const AUTH_CODE = [401, 420];
const ORG_ID_KEY = 'openatom-talent-profile-organization-id';
const base = `${window.location.protocol}//${window.location.host}`;

export const isLogin = () => {
  if (import.meta.env.VITE_MOCK_LOGIN === 'yes') {
    return true;
  }
  else {
    return !!localStorage.getItem(TOKEN_KEY);
  }
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getOrgId = () => {
  return localStorage.getItem(ORG_ID_KEY);
};

export const setOrgId = (orgId: string) => {
  localStorage.setItem(ORG_ID_KEY, orgId)
}

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const gotoLogin = async (from = '/') => {
  const { isSuccess, data } = await $fetch('/api/oauth/v1/authorize/url', {
    data: {
      redirectUri: `${base}${LOGIN_ROUTE_PATH}?from=${encodeURIComponent(from)}`,
    },
  });

  if (isSuccess) {
    window.location.href = data;
  }
};

export const isAuthCode = (code: number) => AUTH_CODE.includes(code);
